import { render, staticRenderFns } from "./BrowserWarn.vue?vue&type=template&id=65d72b46&"
import script from "./BrowserWarn.vue?vue&type=script&lang=js&"
export * from "./BrowserWarn.vue?vue&type=script&lang=js&"
import style0 from "./BrowserWarn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports